import ListCardChutesOthers from 'components/molecules/ListCardChutesOthers/ListCardChutesOthers'
import ListCardChutesAssigned from 'components/molecules/ListCardsChutesAssigned/ListCardChutesAssigned'
import ListCardChutesAvailables from 'components/molecules/ListCardChutesAvailables/ListCardChutesAvailables'
import { LoaderTransparent } from 'components/molecules/LoaderTransparent/LoaderTransparent'
import React, { useEffect, useState } from 'react'
import { showOrder } from 'services/ordersService'
import Message from 'components/atoms/Message/Message'

interface Props {
    orderId: number
}

export default function TemplateShowOrder({ orderId }: Props) {
    const [loading, setLoading] = useState(false)
    const [order, setOrder] = useState({
        assigned: {},
        available: [],
        description: '',
        others: {},
        id: 0,
        state: '',
    })

    const [errorMessage, setErrorMessage] = useState('')
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const data = await showOrder(orderId)
                setOrder(data)
                setLoading(false)
            } catch (error) {
                setErrorMessage('Ha ocurrido un error intente mas tarde')
                setLoading(false)
            }
        }

        fetchData()
    }, [orderId])

    const formatOrder = (orderAssigned: object) => {
        return Object.entries(orderAssigned).map(([key, values]) => {
            return {
                name: key,
                chutes: values,
            }
        })
    }

    return (
        <>
            {loading && <LoaderTransparent />}
            <div className="flex flex-col gap-6">
                {errorMessage && (
                    <Message message={errorMessage} type={'error'} />
                )}
                <ListCardChutesAvailables
                    name="Disponibles"
                    list={order.available}
                />
                <ListCardChutesAssigned
                    name="Asignados"
                    list={formatOrder(order.assigned)}
                />
                <ListCardChutesOthers name="Otros" list={order.others} />
            </div>
        </>
    )
}
